<script setup>
import { useDragAndDrop } from '@/store/modules/drag-and-drop.js'
import { watch, ref, nextTick } from 'vue';

const store = useDragAndDrop()
const dragZone = ref(null)

watch(
    () => store.Dragging,
    async (newValue) => {
        if (newValue) {
            await nextTick()
            dragZone.value?.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
    }
);

</script>

<template>
    <div v-show="store.Dragging" class="drop-preview drop-zone" ref="dragZone" tabindex="-1">
        Arraste para aqui
    </div>
</template>

<style scoped>

.drop-preview {
    text-align: center;
    font-size: 1.5em;
    text-transform: uppercase;
    opacity: .5;
    padding: var(--default-app-padding);
    background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='10' ry='10' stroke='white' stroke-width='5' stroke-dasharray='6%2c 14' stroke-dashoffset='94' stroke-linecap='square'/%3e%3c/svg%3e");
    border-radius: 10px;
    margin-bottom: 10px;
}

</style>